export const DEFAULT_PAGE_SIZE = 7;
export const DEFAULT_EVENT_SIZE = 12;
export const DEFAULT_FAVORITE_EVENT_SIZE = 24;

export const MAX_PAGE_SIZE = 1000;
export const MIN_PAGE = 1;
